import '../scss/style.scss';

window.$ = window.jQuery = require('jquery');

require('./libs/scrollbar');
require('./libs/slick');
require('./libs/css3-animate-it');
require('./header');
require('./header-menu');
require('./sticky-header');
require('./menu-mobile');
require('./slider');
require('./product-list');
require('./allegro-slider');
require('./search-overlay');
require('./multiple-slider');
require('./product-slider-images');
require('./works-slider');
require('./product-gallery');
require('./product-comparison');
require('./faq');
require('./smooth-scroll');
require('./animated.js');
require('./scrollup');